import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateInspectionServiceStoreIds } from '../../api/inspection-service.ts';
import { UpdateInspectionServiceStoreIdsRequest } from '../../api/requests/inspection-service-request.ts';

export default function useUpdateInspectionServiceStoreIds(): UseMutationResult<
  Awaited<ReturnType<typeof updateInspectionServiceStoreIds>>,
  Error,
  UpdateInspectionServiceStoreIdsRequest
> {
  return useMutation({
    mutationFn: updateInspectionServiceStoreIds,
  });
}
